import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_QUERYURL } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';

export const fetchQAHistory = createAsyncThunk(
  'qaHistory/fetchQAHistory',
  async ({ historyId, userId, taskId }) => {
    try {
      const response = await fetch(
        `${BASE_QUERYURL}/question-history?history_id=${historyId}&user_id=${userId}&task_id=${taskId}`,
        authHeaders()
      );
      if (!response.ok) {
        throw new Error('Failed to fetch QA history');
      }
      const data = await response.json();

      console.log(data,'data History')
      return data.qa_pairs;
    } catch (error) {
      throw error;
    }
  }
);

const qaHistorySlice = createSlice({
  name: 'qaHistory',
  initialState: {
    qaHistory: [],
    loading: false,
    error: null,
    historyLoaded: false,
    requestId: null
  },
  reducers: {
    clearQAHistory: (state) => {
      state.qaHistory = [];
      state.historyLoaded = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQAHistory.pending, (state, action) => {
        state.requestId = action.meta.requestId;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQAHistory.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.requestId) return;
        state.loading = false;
        state.qaHistory = action.payload.map(message => ({
          id: message.id,
          role: message.role,
          comment: message.comment || '',
          content: message.content,
          source: message.source || [],
          sources: message.sources || [],
          web_search: message.web_search || false,
          hybrid_search: message.hybrid_search || false,
          timestamp: message.timestamp,
          title: message.title || '',
          // Images this message had attached (File.id + filename, from
          // get_question_answers_with_sources) — this mapping used to be an
          // allowlist that didn't include it at all, so it silently got
          // dropped on every reload even though the backend always sent it
          // correctly: the chat bubble showed only the auto-generated
          // "Please analyze the attached image." fallback text with no
          // image, since Analysis.jsx/ChatBlob.jsx both depend on this field
          // being present to render the thumbnail (and to hide that same
          // fallback text).
          attached_images: message.attached_images || [],
          // Same allowlist gotcha attached_images hit above — which file(s)
          // a "/" picker restriction applied to (get_question_answers_with_
          // sources), display-only.
          restricted_filenames: message.restricted_filenames || null,
          // Same allowlist gotcha again — a finished Word-generation result
          // (get_question_answers_with_sources already resolves the title/
          // filename server-side, no re-polling needed on reload).
          generated_document_id: message.generated_document_id || null,
          generated_document_title: message.generated_document_title || null,
          generated_document_filename: message.generated_document_filename || null,
          generated_document_file_size: message.generated_document_file_size || null,
          analysis_meta: message.analysis_meta || null
        }));
        state.historyLoaded = true;
      })
      .addCase(fetchQAHistory.rejected, (state, action) => {
        if (action.meta.requestId !== state.requestId) return;
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearQAHistory } = qaHistorySlice.actions;
export default qaHistorySlice.reducer; 